import { Button } from '@cibli/shared';
import { Video } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';

import { getInterviewUrl } from '@/lib/interview-url';

interface StoredJob {
  id: string;
  title: string;
}

export default function InterviewStartPage() {
  const { jobId } = useParams<{ jobId: string }>();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [job, setJob] = useState<StoredJob | null>(null);

  useEffect(() => {
    if (!jobId) return;
    const raw = sessionStorage.getItem(`cibli_job_${jobId}`);
    if (raw) {
      try {
        setJob(JSON.parse(raw) as StoredJob);
      } catch {
        // ignore
      }
    }
  }, [jobId]);

  const handleStart = () => {
    const interviewUrl = getInterviewUrl();
    const url = jobId ? `${interviewUrl}?jobId=${encodeURIComponent(jobId)}` : interviewUrl;
    window.location.href = url;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md space-y-8 text-center">
        <div className="space-y-3">
          <Video className="size-12 text-primary mx-auto" />
          <h1 className="text-2xl font-semibold">
            {t('apply.interview.title', 'Entretien vidéo')}
          </h1>
          {job?.title && <p className="text-muted-foreground font-medium">{job.title}</p>}
          <p className="text-muted-foreground text-sm">
            {t(
              'apply.interview.description',
              "Vous allez être redirigé vers notre espace d'entretien. Répondez à quelques questions en vidéo pour compléter votre candidature.",
            )}
          </p>
        </div>

        <div className="space-y-3">
          <Button onClick={handleStart} size="lg" className="w-full">
            {t('apply.interview.start', "Démarrer l'entretien")}
          </Button>
          <Button variant="ghost" size="sm" onClick={() => navigate(`/apply/${jobId}`)}>
            {t('common.back', 'Retour')}
          </Button>
        </div>
      </div>
    </div>
  );
}
